import { Icons } from "../components/Icons.js";
import { ResumesView } from "../notes/ResumesView.js";
import type { EditTarget } from "../notes/types.js";

/** Écran « Comptes rendus » (mobile) : barre + liste des résumés. */
export function ResumesScreen({ onOpen, reloadToken, goBack }: { onOpen: (t: EditTarget) => void; reloadToken: number; goBack: () => void }) {
  return (
    <div className="screen resumes">
      <header className="topbar">
        <button className="iconbtn" onClick={goBack} aria-label="Retour">
          <Icons.Back size={22} />
        </button>
        <div className="screen-title">Comptes rendus</div>
        <span style={{ width: 42 }} />
      </header>
      <div className="resumes-body">
        <ResumesView onOpen={onOpen} reloadToken={reloadToken} />
      </div>
    </div>
  );
}
